import PropTypes from "prop-types";
import React from "react";
import { countryList } from "../../utils/CountryList";

const PhoneInput = ({
  value,
  name,
  onChange,
  dialCode,
  onDialCodeChange,
  error,
  css = "",
  readOnly,
  disabled
}) => {
  const handleKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const borderClass = error ? "border-red-500" : "border-gray-300";

  return (
    <div className={` ${css}`}>
      <label
        htmlFor={name}
        className="block text-sm font-medium text-black mb-1"
      >
        Mobile <span className="text-red-600">*</span>
      </label>

      <div
        className={`flex items-center bg-white border ${borderClass} rounded-md overflow-hidden ${readOnly}`}
      >
        {/* Dial code - 20% */}
        <select
          name="dialCode"
          className="w-[20%]  lg:w-[15%] flex justify-center bg-gray-300 text-black text-sm px-2 py- outline-none border-none"
          value={dialCode}
          onChange={onDialCodeChange}
          disabled={readOnly || disabled}
        >
          {countryList.map((item, index) => (
            <option
              className="text-black  text-sm"
              key={index}
              value={item.dial_code}
            >
              {item.flag} {item.dial_code}
            </option>
          ))}
        </select>

        {/* mobile Input - 80% */}
        <input
          type="tel"
          id={name}
          name={name}
          maxLength="15"
          onWheel={(e) => e.target.blur()}
          onKeyPress={handleKeyPress}
          placeholder="Enter phone number"
          className="w-full -ml-2 py-2 text-sm outline-none text-black bg-transparent border-none"
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          disabled={disabled}
        />
      </div>

      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
};

PhoneInput.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  dialCode: PropTypes.string.isRequired,
  onDialCodeChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  css: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool
};

export default PhoneInput;
